<template>
  <div class='welcome' >
    <div class="showdata_cen">
      <div class="showdata_tit">
          <h2>运力趋势</h2>
          <div class="date">
            <span class="date">时间跨度：</span>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
      </div>
      <div class="showdata_box"> 
        <div class="echart" id="mychart" :style="myChartStyle"></div>
        <div class="echart" id="mychart2" :style="myChartStyle"></div>
        <div class="echart" id="mychart3" :style="myChartStyle"></div>
      </div>
      <div class="echart_tit">
        <h3>司机新增趋势图</h3>
        <h3>车辆新增趋势图</h3>
        <h3>托运人新增趋势图</h3>
       </div>
      <div class="showdata_box"> 
        <div class="echart" id="mychart4" :style="myChartStyle"></div>
        <div class="echart" id="mychart5" :style="myChartStyle"></div>
        <div class="echart" id="mychart6" :style="myChartStyle"></div>
      </div>

     
    </div>
    <el-button>返回</el-button>

  </div>
</template>



<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      xData: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"], //横坐标
      yData: [23, 24, 18, 25, 27, 28, 25], //数据
      myChartStyle: { float: "left", width: "100%", height: "400px" } ,//图表样式
      time1:'',
      options: [{
          value: '选项1',
          label: '本周内'
        }, {
          value: '选项2',
          label: '本月内'
        }, {
          value: '选项3',
          label: '本季度'
        }, {
          value: '选项4',
          label: '本年度'
        }],
        value: '选项1'
    };
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      // 基本柱状图
      const option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#007fcc'
                }
              }
            },
            color: [
                  '#1ebe38', '#007fcc'
               ],
            legend: {
              data: ["司机新增趋势图"],
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 20,

            },
            xAxis: [
              {
                type: 'category',
                data: this.xData,
                axisPointer: {
                  type: 'shadow'
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: '柱状图数值',
                min: 0,
                max: 50,
                interval:10,
                axisLabel: {
                  formatter: '{value} 辆'
                },
                axisLine: {
                show: true,
                lineStyle: {
                  color: '#00bc4b'
                }
              },
              },
              {
                type: 'value',
                name: '折线图数值',
                min: 0,
                max: 30,
                interval: 5,
                axisLabel: {
                  formatter: '{value} 辆'
                },
                axisLine: {
                show: true,
                lineStyle: {
                  color: '#007fcc'
                }
              },
              }
            ],
            series: [
              {
                name: '司机新增柱状',
                type: 'bar',
                tooltip: {
                  valueFormatter: function (value) {
                    return value ;
                  }
                },
                data:  this.yData
                
              },
              {
                name: '司机新增折线',
                type: 'line',
                yAxisIndex: 1,
                data: this.yData
              }
            ]
          };

      const myChart = echarts.init(document.getElementById("mychart"));
      const myChart2 = echarts.init(document.getElementById("mychart2"));
      const myChart3 = echarts.init(document.getElementById("mychart3"));
      const myChart4 = echarts.init(document.getElementById("mychart4"));
      const myChart5 = echarts.init(document.getElementById("mychart5"));
      const myChart6 = echarts.init(document.getElementById("mychart6"));
      myChart.setOption(option);
      myChart2.setOption(option);
      myChart3.setOption(option);
      myChart4.setOption(option);
      myChart5.setOption(option);
      myChart6.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
        myChart2.resize();
        myChart3.resize();
        myChart4.resize();
        myChart5.resize();
        myChart6.resize();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.welcome{
  margin: 0;
  padding: 0;
  width: 98%;
  margin-top: 20px;
  .showdata_cen{
    width: 96%;
    border:1px solid #007fcc;
    border-radius: 10px;
    margin-left: 3%;
    padding: 20px;
    .showdata_tit{
      width: 100%;
      display: flex;
      h2{
        flex: 3;
      }
      .date{
        flex: 1;
        text-align: right;
      }
    }
    .showdata_box{
      width: 100%;
      display: flex;
      .echart{
        flex: 1;
      }
      
    }
    .echart_tit{
        width: 100%;
        height: 40px;
        display: flex;
        position: relative;
        top:-30px;
        h3{
          flex: 1;
          text-align: center;
        }

      }

  }
}
</style>


// WEBPACK FOOTER //
// src/page/welcome_map.vue